import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { createResponsiveDialogSize } from '../../utils/static-functions';
import { SelectionDialogComponent } from './selection-dialog.component';
import { SelectionDialogParams } from './selection-dialog.params';

@Injectable({ providedIn: 'root' })
export class SelectionDialogService {
  private readonly _dialog = inject(MatDialog);

  select<T, F = Record<string, unknown>>(
    params: SelectionDialogParams<T, F> & { selectionMode?: 'single' },
  ): Observable<T | null>;
  select<T, F = Record<string, unknown>>(
    params: SelectionDialogParams<T, F> & { selectionMode: 'multi' },
  ): Observable<T[] | null>;
  select<T, F = Record<string, unknown>>(
    params: SelectionDialogParams<T, F>,
  ): Observable<T | T[] | null> {
    const size = createResponsiveDialogSize();
    return this._dialog
      .open<SelectionDialogComponent<T>, SelectionDialogParams<T, F>, T | T[] | null>(
        SelectionDialogComponent,
        {
          data: params,
          width: params.width ?? size.width,
          height: params.height ?? size.height,
          maxWidth: size.maxWidth,
          maxHeight: size.maxHeight,
        },
      )
      .afterClosed()
      .pipe(map(result => result ?? null));
  }
}
